<template>
  <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :modal="false" width="430px">
    <div class="mb10">
      <p class="text-center" style="font-weight: 700;">项目中以下信息有改动，是否更新到公司详情？</p>
      <p class="text-center" style="font-weight: 700;">勾选需要更新的选项，点击保存即可</p>
    </div>
    <div v-if="questions.length > 0" class="mb10">
      <p>客户最关注的问题新增</p>
      <div v-for="(question, index) in questions" :key="index" class="display-flex align-center mb5">
        <span class="mr5">Q:</span>
        <p>{{ question }}</p>
        <el-checkbox v-model="insertQuestions[question]"></el-checkbox>
      </div>
    </div>

    <div v-if="hrs.length > 0" class="mb10">
      <p>对接hr新增</p>
      <div v-for="(item, index) in hrs" :key="index" style="display: flex;">
        <div class="radish-card mr10 mb5">
          <span class="close" @click="removeProjectHr(item)">X</span>
          <div style="width:40%">
            <span class="name">
              <!-- {{item.姓名}} -->
              <span class="drawer-link" @click="showRadish(item._id)">{{ item.姓名 }}</span>
            </span>
            <span class="name" style="color:#000">
              <span>{{ item.目前职位 }}</span>
            </span>
          </div>
          <div class="width:60%">
            <p class="tel">{{ item.手机 }}</p>
            <p>{{ item.座机 }}</p>
            <p>{{ item.邮箱 }}</p>
          </div>
        </div>
        <el-checkbox v-model="insertHrs[item._id]"></el-checkbox>
      </div>
    </div>

    <span slot="footer" class="dialog-footer">
      <span class="mr10"> <el-button size="mini" type="danger" @click="onCancel">取 消</el-button> </span>
      <el-button size="mini" type="primary" @click="onConfirm">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  props: {
    project: { type: Object, default: () => ({}) },
    company: { type: Object, default: () => ({}) },
  },
  data() {
    return {
      dialogVisible: false,
      questions: [],
      hrs: [],
      insertQuestions: {},
      insertHrs: {},
    }
  },
  methods: {
    async open({ questions = [], hrs = [] }) {
      this.questions = questions.filter(val => val)
      this.hrs = hrs
      if (this.questions.length === 0 && this.hrs.length === 0) return this.$emit('cancel')
      const insertQuestions = {}
      const insertHrs = {}
      questions.forEach(val => (insertQuestions[val] = true))
      this.insertQuestions = insertQuestions
      hrs.forEach(val => (insertHrs[val._id] = true))
      this.insertHrs = insertHrs
      this.dialogVisible = true
    },
    onCancel() {
      this.dialogVisible = false
      this.$emit('cancel')
    },
    async onConfirm() {
      const addQuestion = this.questions.filter(val => this.insertQuestions[val])
      const addHr = this.hrs.filter(val => this.insertHrs[val._id])
      const res = await app
        .service('company')
        .projectAddCompanyData({ cid: this.company._id, option: { questions: addQuestion, hrs: addHr } })
      if (res.status === 'success') this.$emit('projectAddCompanyData')
      this.dialogVisible = false
    },
    showRadish(rid) {
      if (!rid) return
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`, '_blank')
    },
  },
}
</script>
<style scoped>
.display-flex {
  display: flex;
}
.cutoff-line {
  flex: 1;
  height: 1px;
  background-color: #c9c7c7;
  align-self: center;
}
.confirm-btn-box {
  border: 1px solid #d7d7d7;
  border-radius: 4px;
  padding: 8px;
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.confirm-btn-box span {
  font-size: 12px;
}
</style>
